// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__-Zf-r","header":"ReportDetails_header__2AG_p","title":"ReportDetails_title__38fpe","left":"ReportDetails_left__2afEe"};